import { render, staticRenderFns } from "./BulkShipment.vue?vue&type=template&id=213b1589&scoped=true&"
import script from "./BulkShipment.vue?vue&type=script&lang=js&"
export * from "./BulkShipment.vue?vue&type=script&lang=js&"
import style0 from "./BulkShipment.vue?vue&type=style&index=0&id=213b1589&prod&lang=css&"
import style1 from "./BulkShipment.vue?vue&type=style&index=1&id=213b1589&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213b1589",
  null
  
)

export default component.exports